import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { FiTrash2 } from "react-icons/fi";
import { FiPlusCircle } from "react-icons/fi";
import { getBreakTypeList, getLocationFilterList, getLocationList, getZipCodeInfo } from '../../components/AddLocation/endpoints/action';
import { addNewLocation, editLocation, saveMapLatAndLng, getMapCandiadates } from './endpoints/action';
import { setAction, setLocationsName } from './endpoints/slice';
//import { companySelector } from "../../components/AddCompany/endpoints/selector";
import { addLocationSelector } from "./endpoints/selector";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import "./addLocation.css";
import Maps from '../common/Maps';
import Modal from '../common/Modal/modal';
import CandidateMap from "../common/Maps/candidateMap";
import DisplayModal from "../common/Modal/displayModal";

import { useNavigate } from "react-router-dom";
import { getLocationDistanceList } from "../common/Header/action";
import { BreakType } from "./breakType";
import { locationsSelector } from "../Locations/selector";
import BankInfoModal from "../common/Modal/BankInfoModal";


// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const [emrSystemList, setEmrSystemList] = useState([{ isOther: false, otherEmrehrsystem: "" }]);
  const [otherEmrsystem, setOtherEmrsystem] = useState([]);
  const emrehrsList = props.emrehrsList;
    // Update Break Type 
  const [updateBreakType, setUpdateBreakType] = useState({});
  const locationDetails = 
   Object.values(updateBreakType)?.length ? updateBreakType : 
  props.locationDetails;

  const travelDistancesList = props.travelDistancesList;
  const timeZonesDropdownList = props.timeZonesDropdownList;
  const { successMessage, errorMessage, locationMapCandidateList, saveButtonDisabled } = useSelector(addLocationSelector);
  
  const isAction = props.isAction;
  const navigate = useNavigate();

  const [form, setForm] = useState({
    locationName: '',
    streetAddress: '',
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const { zipCodeInfo } = useSelector(addLocationSelector);
  const dispatch = useDispatch();

  const [locationName, setLocationName] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [city, setCity] = useState('');
  const [stateName, setStateName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [timeZone, setTimeZone] = useState('');
  const [acceptableTravelDistance, setAcceptableTravelDistance] = useState('');
  const [emrSystems, setEmrSystems] = useState([]);
  const [defaultEmrEhr, setDefaultEmrehr] = useState([]);
  const [emhEhrSystem, setEmhEhrSystem] = useState(defaultEmrEhr);
  const [newEmrEhr, setNewEmrEhr] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [locationsDetails, setLocationsDetails] = useState(locationDetails);
  const [showModal2, setShowModal2] = useState(false);
  // Break Type state
  const [rowData, setRowData] = useState([]);
  // Break Type Edit state
  const [previousBreakState, setPreviousBreakState] = useState([]);
  // Break Type Disable button
  const [breakTypeDisableBtn, setBreakTypeDisableBtn] = useState(false);

  const [editId, setEditId] = useState("");
  const [showBankInfoModal,setShowBankInfoModal] = useState({status:false,location:null, getURL:null,postURL:null});

  // updated Prams
  const updateBreakTypeParams = rowData?.map((item) => (
    {
      locationsWorkBreakSettingId: locationDetails ? item?.locationsWorkBreakSettingId : 0,
      locationId: locationDetails ? item?.locationId : 0,
      breakTypeId: item.breakTypeId,
      durationInMinutes: item.durationInMinutes,
      isPaidBreak: item?.isPaidBreak,
      isDeleted: 0
    }
  ))

  useEffect(() => {
    if (locationDetails) {
      setLocationName(locationDetails.locationName);
      setStreetAddress(locationDetails.streetAddress);
      setZipcode(locationDetails.zipcode);
      setCity(locationDetails.city);
      setStateName(locationDetails.stateName);
      setPhoneNumber(locationDetails.phoneNumber);
      setTimeZone(locationDetails.timezone)
      setAcceptableTravelDistance(locationDetails.acceptableTravelDistance);
      setLatitude(locationDetails.approxLatitude)
      setLongitude(locationDetails.approxLongitude);
    
      let valueList = [];
      locationDetails.locationOtherEMREHR.map((otherEmrEhr, index) => {
        if (otherEmrEhr.isOther === true)
          valueList.push({ isOther: otherEmrEhr.isOther, otherEmrehrsystem: otherEmrEhr.otherEMREHRSystemName });
      });
      if (valueList.length > 0) {
        setOtherEmrsystem(valueList);
      } else {
        setOtherEmrsystem([{ isOther: false, otherEmrehrsystem: "" }])
      }

      /* locationDetails.locationOtherEMREHR.map((otherEmrEhr, index) => { 
        setOtherEmrsystem([...otherEmrsystem, { isOther: otherEmrEhr.isOther, otherEmrehrsystem: otherEmrEhr.otherEMREHRSystemName }]);
      }) */

      let emrehrLists = [];
      locationDetails.locationEMREHR.map((list, n) => {
        let a = emrSystems.filter(emrehr =>
          emrehr.id === list.emrehrSystemId
        );

        let emrehrList = {};
        if (a.length > 0) {
          emrehrList['value'] = a[0].id;
          emrehrList['label'] = a[0].name;
          emrehrLists.push(emrehrList);
        }
      });
      setDefaultEmrehr(emrehrLists);

    } else {
      setLocationName('');
      setStreetAddress('');
      setZipcode('');
      setCity('');
      setStateName('');
      setPhoneNumber('');
      setTimeZone('')
      setAcceptableTravelDistance('');
      setLatitude('')
      setLongitude('')
      setEmrSystemList([{ isOther: false, otherEmrehrsystem: "" }]);
      setDefaultEmrehr([])
      setRowData(
        rowData.map((item) => ({
        breakTypeId: item.breakTypeId,
        breakTypes: item.breakTypes,
        durationInMinutes: "",
        isPaidBreak: '',
      })))
    }
  }, [locationDetails]);


  useEffect(() => {
    if (locationDetails && config.baseUrl) {
      if (locationDetails.locationId && locationDetails.approxLatitude && locationDetails.approxLongitude) {
        const val = {
          "locationId": locationDetails.locationId,
          "latitude": locationDetails.approxLatitude,
          "longitude": locationDetails.approxLongitude
        }
        dispatch(getMapCandiadates({ url: `${config.baseUrl}/Locations/location-map-candidates`, val: val }));
      }
    }
  }, [config.baseUrl])

  useEffect(() => {
    defaultEmrEhr.map(emrehr => {
      setEmhEhrSystem([
        ...emhEhrSystem, { emrehrsystemId: emrehr.value }
      ]);
    });

  }, [defaultEmrEhr.length > 0]);


  useEffect(() => {
    let emrList = [];
    emrehrsList.map((list, n) => {
      let emrehrData = {};
      emrehrData['value'] = list.id;
      emrehrData['label'] = list.name;
      emrList.push(emrehrData);
    });
    setEmrSystems(emrList);

    if (locationDetails) {
      let emrehrLists = [];
      locationDetails.locationEMREHR.map((list, n) => {
        let a = emrList.filter(emrehr =>
          emrehr.value === list.emrehrSystemId
        );

        let emrehrList = {};
        if (a.length > 0) {
          emrehrList['value'] = a[0].value;
          emrehrList['label'] = a[0].label;
          emrehrLists.push(emrehrList);
        }
      });
      setDefaultEmrehr(emrehrLists);

    }
  }, [emrehrsList]);

  useEffect(() => {
    if (otherEmrsystem.length > 0)
      setEmrSystemList(otherEmrsystem);
  }, [otherEmrsystem]);



  useEffect(() => {
    if (successMessage == 'New Location added successfully!' && isAction === 'add') {
      setLocationName('');
      setStreetAddress('');
      setZipcode('');
      setCity('');
      setStateName('');
      setPhoneNumber('');
      setTimeZone('')
      setAcceptableTravelDistance('');
      setLatitude('')
      setLongitude('')
      setEmrSystemList([{ isOther: false, otherEmrehrsystem: "" }]);
      setNewEmrEhr([])
      setRowData(
        rowData.map((item) => ({
        breakTypeId: item.breakTypeId,
        breakTypes: item.breakTypes,
        durationInMinutes: "0",
        isPaidBreak: '',
      })))
    }
  }, [successMessage]);



  useEffect(() => {
    if (errorMessage && isAction === 'add') {
      setLocationName('');
      setStreetAddress('');
      setZipcode('');
      setCity('');
      setStateName('');
      setPhoneNumber('');
      setTimeZone('')
      setAcceptableTravelDistance('');
      setLatitude('')
      setLongitude('')
      setEmrSystemList([{ isOther: false, otherEmrehrsystem: "" }]);
      setNewEmrEhr([])
      setRowData(
        rowData.map((item) => ({
        breakTypeId: item.breakTypeId,
        breakTypes: item.breakTypes,
        durationInMinutes: "",
        isPaidBreak: '',
      })))
    }
  }, [errorMessage]);



  const handleSystemAdd = () => {
    setEmrSystemList([...emrSystemList, { isOther: false, otherEmrehrsystem: "" }]);
  };

  const handleSystemRemove = (index) => {
    const list = [...emrSystemList];
    list.splice(index, 1);
    setEmrSystemList(list);
  };

  const handleSystemChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...emrSystemList];
    list[index][name] = value;
    list[index]['isOther'] = true;
    setEmrSystemList(list);
  };

  useEffect(() => {
    if (zipcode && zipcode.length === 5)
      dispatch(getZipCodeInfo(config.baseUrl, zipcode));
  }, [zipcode && zipcode.length === 5]);

  useEffect(() => {
    if(zipcode && zipcode.length===5)
    {
    if (zipCodeInfo)
      setCity(zipCodeInfo.city);
    setStateName(zipCodeInfo.state);
    setIsDisabled(true);
    }
  }, [zipCodeInfo]);

  useEffect(() => {
    if (config.baseUrl) {
      dispatch(getBreakTypeList(config.baseUrl)).then((response) => {
        if (response && response?.length) {
        const val =  response.map(item => {
            const matchingBreakSetting = locationDetails?.locationWorkBreakSetting
            .find(setting => setting.breakTypeId === item.breakTypeId);
            return {
              breakTypeId: item.breakTypeId,
              breakTypes: item.breakTypes,
              durationInMinutes: locationDetails ? (matchingBreakSetting ? matchingBreakSetting.durationInMinutes : "") : "",
              isPaidBreak: locationDetails ? (matchingBreakSetting ? matchingBreakSetting.isPaidBreak : '') : '',
              locationsWorkBreakSettingId: locationDetails ? (matchingBreakSetting ? matchingBreakSetting.locationsWorkBreakSettingId : '') : '',
              locationId: locationDetails ? locationDetails?.locationId : '',
            };
          })
          setRowData(val);
          setPreviousBreakState(response)
        }
      })
    }
  },[config, updateBreakType])


  const setEmrEhrValue = (value, emrehrsystemId) => {

    let valueList = [];
    value.map((key, n) => {
      valueList.push({ emrehrsystemId: key.value });
    });

    setEmhEhrSystem(valueList);

    let valuesList = [];
    value.map((key, n) => {
      valuesList.push({ value: key.value, label: key.label });
    });

    setNewEmrEhr(valuesList);
  }

  const editEmrEhrValue = (value, emrehrsystemId) => {

    let valuesList = [];
    value.map((key, n) => {

      valuesList.push({ value: key.value, label: key.label });
      /* setDefaultEmrehr([
        ...defaultEmrEhr, {value: key.value, label: key.label}
      ]) */
    });
    setDefaultEmrehr(valuesList);

    let valueList = [];
    value.map((key, n) => {
      valueList.push({ emrehrsystemId: key.value });
    });
    setEmhEhrSystem(valueList);


  }


  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const validatePhoneNumber = (value) => {
    value = formatPhoneNumber(value);
    setPhoneNumber(value);
  }

  
  const validateZipcode = (value) => {
    value = formatZipcode(value);
    setZipcode(value);
  }

  
  const formatZipcode = (value) => {
    if (!value) return value;
    const ZipcodeNumber = value.replace(/[^\d]/g, '');
    
    if (ZipcodeNumber.length <= 6)
    {
      return ZipcodeNumber;
    }
    else
    {
     return `${ZipcodeNumber.slice(0, 6)}`;
    }
  }

  function cancel() {
    navigate('/locations')
  }

  const validateForm = () => {
    //const {locationName, streetAddress, zipcode, stateName, city, phoneNumber, timezone, acceptableTravelDistance} = form;
    const newErrors = {};
    const phoneno = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;

    const zipcodePattern = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;

    if (!locationName || locationName === '') newErrors.locationName = "Please enter the Location Name"
    if (!streetAddress || streetAddress === '') newErrors.streetAddress = "Please enter the street Address"
    if (!zipcode || zipcode === '') newErrors.zipcode = "Please enter the Zip Code"
    if (!stateName || stateName === '') newErrors.stateName = "Please enter the State"
    if (!city || city === '') newErrors.city = "Please enter the City"
    if (!phoneNumber || phoneNumber === '') {
      newErrors.phoneNumber = "Please enter the Phone number"
    } else if (!phoneNumber.match(phoneno)) {
      newErrors.phoneNumber = "Phone number should be a 10 digit number"
    }
    if (!acceptableTravelDistance || acceptableTravelDistance === '') newErrors.acceptableTravelDistance = "Please enter the Travel Distance"
    if (!timeZone || timeZone.length === 0) newErrors.timeZone = "Please enter the TimeZone"
    // if (!emhEhrSystem || emhEhrSystem.length === 0) newErrors.emhEhrSystem = "Please enter the EMR EHR system"

    if (!locationDetails) {
    rowData?.map((item) => {
      const duration = parseInt(item?.durationInMinutes);
      if (isNaN(duration) || duration === 0) {
        newErrors.breakType = 'Please select a the duration';
      }
      return null
    })
  
    rowData?.map((item) => {
      const paidBreak = item?.isPaidBreak;
      if (paidBreak === '') {
        newErrors.paidBreak = 'Please select any one';
      }
      return null
    })
  } else if (editId) {
    const filterRow = rowData?.find((item) => item?.breakTypeId === editId);
    
    if (filterRow?.durationInMinutes === '' || filterRow?.durationInMinutes === 0 || filterRow?.durationInMinutes === '0') {
      newErrors.breakType = 'Please select a the duration';
    }

    if (filterRow?.isPaidBreak === '') {
      newErrors.paidBreak = 'Please select any one';
    }
  }

    return newErrors
  }


  const validateAndSubmit = (e, action, showBankInfo ) => {
    e.preventDefault();

    const body = document.querySelector('#root');

    body.scrollIntoView({
      behavior: 'smooth'
    }, 500)

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      if(!showBankInfo){
        dispatch(setAction(action));
        dispatch(setLocationsName(locationName));
      }
      setErrors([]);
      if (isAction === 'add') {
        dispatch(addNewLocation(config.baseUrl, {
          locationId: 0,
          employerId: login.employerId,
          locationName: locationName,
          acceptableTravelDistance: acceptableTravelDistance,
          zipcode: zipcode,
          city: city,
          stateName: stateName,
          country: "",
          streetAddress: streetAddress,
          phoneNumber: phoneNumber,
          timezone: timeZone,
          createdBy: login.appUserId,
          locationEmrEhrsystem: emhEhrSystem,
          locationOtherEmrEhrsystem: emrSystemList,
          locationsWorkBreakSettingParameters: updateBreakTypeParams
        }, action)).then(response => {
         dispatch(getLocationList({baseUrl:config.baseUrl, empID:login.employerUniqueId})).then(locationList => {
          const location = locationList?.find(loc => loc?.id === response?.locationId);
          if(showBankInfo && response?.locationId && location){
            setShowBankInfoModal(prev => ({...prev, status:true,location:location, postURL:`BankAccount/create-bank-account`}));
          }
          dispatch(getLocationDistanceList({baseUrl:config.baseUrl, employerId:login.employerId, employerUniqueId:login.employerUniqueId}))
         })

          // Form Reset
          setLocationName('');
          setStreetAddress('');
          setZipcode('');
          setCity('');
          setStateName('');
          setPhoneNumber('');
          setTimeZone('')
          setAcceptableTravelDistance('');
          setLatitude('')
          setLongitude('')
          setEmrSystemList([{ isOther: false, otherEmrehrsystem: "" }]);
          setNewEmrEhr([])
          setRowData(
            rowData.map((item) => ({
            breakTypeId: item.breakTypeId,
            breakTypes: item.breakTypes,
            durationInMinutes: "",
            isPaidBreak: '',
          })))

        });
      } else if (isAction === 'edit') {
        dispatch(editLocation(config.baseUrl, {
          locationId: locationDetails.locationId,
          employerId: login.employerId,
          locationName: locationName,
          acceptableTravelDistance: acceptableTravelDistance,
          zipcode: zipcode,
          city: city,
          stateName: stateName,
          country: "",
          streetAddress: streetAddress,
          phoneNumber: phoneNumber,
          timezone: timeZone,
          createdBy: login.appUserId,
          locationEmrEhrsystem: emhEhrSystem,
          locationOtherEmrEhrsystem: emrSystemList,
          // locationsWorkBreakSettingParameters: updateBreakTypeParams
        }, action)).then(response => {
          dispatch(getLocationList({baseUrl:config.baseUrl, empID:login.employerUniqueId})).then(() => {
            dispatch(getLocationDistanceList({baseUrl:config.baseUrl, employerId:login.employerId, employerUniqueId:login.employerUniqueId}))
          })
        });
      }
    }

  }

  useEffect(() => {
    if (config.baseUrl && locationDetails) {
      dispatch(getLocationFilterList(config.baseUrl, login.employerId, login.employerUniqueId, locationDetails.locationId)).then((response) => {
        setUpdateBreakType(response)
      })
    }
  },[config])

  const showMap = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
  };
  const showMap2 = (event) => {
    event.preventDefault();
    setShowModal2(!showModal2);
  };
  const closeMap = (event) => {
    event.preventDefault();
    setShowModal(!showModal);

  };
  const closeMap2 = (event) => {
    event.preventDefault();
    setShowModal2(!showModal2);

  };
  const setLatLng = (e) => {
    if (e.latLng.lat() && e.latLng.lng()) {
      setLatitude(e.latLng.lat())
      setLongitude(e.latLng.lng())
    }
  }

  const saveLatLng = () => {
    if (longitude && latitude && locationDetails.locationId) {
      const mapData = {
        "locationId": locationDetails.locationId,
        "latitude": latitude,
        "longitude": longitude
      };
      dispatch(saveMapLatAndLng({ url: `${config.baseUrl}/Locations/update-location-latitude-longtitude`, val: mapData }));
    }
    setShowModal(!showModal);
  }


  return (
    <div class="panel-body tabs-menu-body">
      <div class="tab-content">
        <div class="tab-pane active" id="tab25">
          <div>
            <div>
              
              {
                showModal && <Modal showHide={closeMap} saveFunction={saveLatLng} label={"Map"}>
                  {locationDetails && locationDetails.approxLatitude && locationDetails.approxLongitude &&
                    <Maps
                      googleMapURL={config.mapURL}
                      containerElement={<div style={{ height: '400px' }} />}
                      mapElement={<div style={{ height: '100%' }} />}
                      loadingElement={<div style={{ height: `100%` }} />}
                      lat={latitude}
                      lng={longitude}
                      setLatLng={setLatLng}
                    />}
                </Modal>
              }
               {showBankInfoModal?.status ? <BankInfoModal showBankInfoModal={showBankInfoModal}  updateBankInfoModal={setShowBankInfoModal}/> : null }
              {/* {
                showModal2 && <DisplayModal showHide={closeMap2} label={"Candidate Map"}>
                  {locationDetails && locationDetails.approxLatitude && locationDetails.approxLongitude &&
                    <CandidateMap
                      googleMapURL={config.mapURL}
                      containerElement={<div style={{ height: '550px' }} />}
                      mapElement={<div style={{ height: '100%' }} />}
                      loadingElement={<div style={{ height: `100%` }} />}
                      lat={latitude}
                      lng={longitude}
                      locationMapCandidateList={locationMapCandidateList}
                    />}
                </DisplayModal>
              } */}
 <div className="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">


            <div className="d-flex gap-2 mb-3">
            <button href="#tab25" className={!props?.showContacts ? 'active btn btn-success' : ''} data-bs-toggle="tab" onClick={() => props?.setShowContacts(false)} >Details</button>
            {!props?.hideContacts && <button href="#tab26" className={props?.showContacts ? 'active btn btn-success' : 'btn btn-success'} data-bs-toggle="tab" onClick={() => props?.setShowContacts(true)} >Contacts</button>}
            </div>
            {props?.showContacts && <div class="newLocation"><button class="btn btn-success" onClick={props?.addNewContact}>Add New Contact</button></div>}




            <div>
                <Form autoComplete="off" noValidate>
                  <Row>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="locationName">
                      <Form.Label>Location name<span class="required">*</span>
                         {props && props.isMapActive && <span className="ms-3 pull-right" onClick={showMap}> <i className="fa fa-map-pin fa-lg"></i></span>}
                        {/* {props && props.isMapActive && <span className="pull-right" onClick={showMap2}> <i className="fa fa-map-marker fa-lg"></i></span>} */}
                      </Form.Label>
                      <Form.Control type="text"
                        placeholder="Location name" value={locationName}
                        onChange={e => {
                          setLocationName(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.locationName} />
                      <Form.Control.Feedback type="invalid">
                        {errors.locationName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="streetAddress">
                      <Form.Label>Street<span class="required">*</span></Form.Label>
                      <Form.Control type="text"
                        placeholder="Street" value={streetAddress}
                        onChange={e => {
                          setStreetAddress(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.streetAddress} />
                      <Form.Control.Feedback type="invalid">
                        {errors.streetAddress}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                   
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="zipcode">
                      <Form.Label>Zip<span class="required">*</span></Form.Label>
                      <Form.Control type="text"
                        placeholder="ZipCode" value={zipcode}
                        onChange={e => {
                          // setZipcode(e.currentTarget.value)
                          validateZipcode(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.zipcode} />
                      <Form.Control.Feedback type="invalid">
                        {errors.zipcode}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="city">
                      <Form.Label>City<span class="required">*</span></Form.Label>
                      <Form.Control type="text"
                        placeholder="City" value={city}
                        onChange={e => {
                          setCity(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.city} />
                      <Form.Control.Feedback type="invalid">
                        {errors.city}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                   
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="stateName">
                      <Form.Label>State<span class="required">*</span></Form.Label>
                      <Form.Control type="text"
                        placeholder="State" value={stateName}
                        onChange={e => {
                          setStateName(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.stateName} />
                      <Form.Control.Feedback type="invalid">
                        {errors.stateName}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="phoneNumber">
                      <Form.Label>Phone<span class="required">*</span></Form.Label>
                      <Form.Control type="text"
                        placeholder="Phone" value={phoneNumber}
                        onChange={e => {
                          validatePhoneNumber(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.phoneNumber} />
                      <Form.Control.Feedback type="invalid">
                        {errors.phoneNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row>
                    
                    <Form.Group
                      as={Col}
                      className="form-group col-md-6 mb-0"
                      controlId="acceptableTravelDistance"
                    >
                      <Form.Label>Acceptable Travel Distance<span class="required">*</span></Form.Label>
                      <Form.Control as="select" value={acceptableTravelDistance}
                        onChange={e => {
                          setAcceptableTravelDistance(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.acceptableTravelDistance}>
                        <option value="">--Select--</option>
                        {travelDistancesList.map((area, n) => (
                          <option key={`traveldistance_${n}`} value={area.id}>
                            {area.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.acceptableTravelDistance}
                      </Form.Control.Feedback>
                    </Form.Group>
                  
                    <Form.Group as={Col} className="form-group col-md-6 mb-0" controlId="timezone">
                      <Form.Label>Time Zone<span class="required">*</span></Form.Label>
                      <Form.Control as="select" style={{ width: "49%" }}
                        value={timeZone}
                        onChange={e => {
                          setTimeZone(e.currentTarget.value)
                        }}
                        isInvalid={!!errors.timeZone} >
                        <option value="">--Select--</option>
                        {timeZonesDropdownList.map((area, n) => (
                          <option key={`timezone_${n}`} value={area.convertionTimezone}>
                            {area.displayText}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.timeZone}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Form>
              </div>
              {locationDetails &&
              <div class=" text-end formButton">
              <button class="btn btn-success " type="submit" onClick={(e) => validateAndSubmit(e, 'save')} disabled={locationDetails ? breakTypeDisableBtn : saveButtonDisabled}>
                Save
              </button>
              <button class="btn btn-success " type="submit" onClick={(e) => validateAndSubmit(e, 'add')} disabled={locationDetails ? breakTypeDisableBtn : saveButtonDisabled}>
                Save and Add Contact
              </button>
              <button class="btn btn-outline-primary" onClick={cancel} disabled={locationDetails ? breakTypeDisableBtn : saveButtonDisabled}>
                Cancel
              </button>
            </div>
              }

            </div>
          </div>
        </div>
      </div>

            </div>

            {/* <div class="card" style={{ display: "none" }}>
              <div class="col-lg-12 col-md-12">
                <div class="row">
                  <div class="card-header">
                    <div class="col-lg-12 col-md-12">
                      <h4>EMR/EHR System Experience*</h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="col-lg-12 col-md-12">
                      <label class="form-label">Select EMR/EHR System</label>
                      {isAction === 'add' && <Select
                        name="emrehrsystemId"
                        closeMenuOnSelect={false}
                        value={newEmrEhr}
                        isMulti
                        options={emrSystems}
                        onChange={e => setEmrEhrValue(e, 'emrehrsystemId')}
                      />}
                      {isAction === 'edit' && <Select
                        name="emrehrsystemId"
                        closeMenuOnSelect={false}
                        value={defaultEmrEhr}
                        isMulti
                        options={emrSystems}
                        onChange={e => editEmrEhrValue(e, 'emrehrsystemId')}
                      />}
                      <span class="errorMsg">{errors.emhEhrSystem}</span>
                    </div>
                  </div>
                  <div class="card-body"  style={{ display: "none" }}>
                    <div class="col-lg-12 col-md-12">
                      <div class="row">
                        <div
                          class="col-lg-12 col-md-12"
                          id="divAddEMREHRSystem"
                        >
                          <div class="row" id="">
                            <label class="form-label">
                              Other EMR/EHR System experience
                            </label>
                            {emrSystemList.map((singleSystem, index) => (
                              <div class="emrsystem">
                                <div class="firstDivision">
                                  <input
                                    name="otherEmrehrsystem"
                                    type="text"
                                    class="form-control"
                                    id="othercertifyname"
                                    placeholder="List EMR/EHR System"
                                    value={singleSystem.otherEmrehrsystem}
                                    onChange={(e) =>
                                      handleSystemChange(e, index)
                                    }
                                  />
                                  {emrSystemList.length - 1 === index && (
                                    <button
                                      id="bDel"
                                      type="button"
                                      title="Delete"
                                      style={{ "fontSize": "1rem" }}
                                      onClick={handleSystemAdd}
                                    >
                                      <FiPlusCircle /> Add new
                                    </button>
                                  )}
                                </div>
                                <div className="secondDivision">
                                  {emrSystemList.length > 1 && (
                                    <button
                                      type="button"
                                      className="remove-btn"
                                      style={{ "fontSize": "1rem" }}
                                      onClick={() => handleSystemRemove(index)}
                                    >
                                      <FiTrash2 />
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
  
   {/* https://development.overturexl.com/devworkbreakapi/api */}

      <div className="page-header">
          <h1 className="page-title">Locations - Work Break Settings<span className="text-danger">*</span></h1>
          {/* {locationDetails?.isBreakTypeMapped === false ? 
          <h5 className="bg-danger text-white mt-2 p-2 border-0 rounded-2">These are the default break set up, please map the actual break minutes for this feature to work</h5> 
          : ''} */}
      </div>

        <BreakType locationDetails={locationDetails}  
        errors={errors} 
        rowData={rowData} 
        setRowData={setRowData} 
        validateForm={validateForm} 
        setErrors={setErrors} 
        previousBreakState={previousBreakState} 
        setPreviousBreakState={setPreviousBreakState}
        breakTypeDisableBtn = {breakTypeDisableBtn}
        setBreakTypeDisableBtn = {setBreakTypeDisableBtn}
        setUpdateBreakType={setUpdateBreakType}
        editId={editId}
        setEditId={setEditId}
        />

    {!locationDetails &&
    <div className="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
            <div class=" text-end formButton">
              <button class="btn btn-success " type="submit" onClick={(e) => validateAndSubmit(e, 'save')} disabled={saveButtonDisabled}>
                Save
              </button>
              <button class="btn btn-success " type="submit" onClick={(e) => validateAndSubmit(e, 'add')} disabled={saveButtonDisabled}>
                Save and Add Contact
              </button>
              <button class="btn btn-success" onClick={(e) => validateAndSubmit(e, 'add', true)} >
                Save and Add Bank Info
              </button>
              <button class="btn btn-outline-primary" onClick={cancel} disabled={saveButtonDisabled}>
                Cancel
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    }
         
          </div>
        </div>
      </div>
    </div>
  );
};
